
import PromiseUtility from "../../../../utility/promiseUtility";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import Q2MySeatCardsBase from "./q2_myseat_cards_base";
import { Card } from "./q2_card_common";
const { ccclass, property, menu } = cc._decorator;


@ccclass
export default class Q2MySeatCards extends Q2MySeatCardsBase{

    @property(cc.Float)
    comingCardPosOffsetX: number = 300

    @property(cc.Float)
    fapaiOffsetY: number = -80

    @property(cc.Float)
    activeDragDistance: number = 40

    isPlayingMoveAnim: boolean = false


    protected m_touch_start_offset: cc.Vec2 = null

    protected m_touch_start_pos: cc.Vec2 = null
    protected m_isDraging: boolean = false

    protected m_dragPokerCallback: Function = null
    setDragPokerCallback(callback){
        this.m_dragPokerCallback = callback 
    }

    playCardOutAnim(codeList: number[], onFinish?: Function){
        let self = this
        this.m_isDraging = false
        this.mFirstHoverPoker = null
        this.mLastHoverPoker = null
        let tmpMap = {}
        for (let index = 0; index < codeList.length; index++) {
            let code = codeList[index];
            code = Card.codeToLogicCode(code) 
            tmpMap[code] = true
        }
        let pokerList = []
        let pokers = self.pokers
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            let code = Card.codeToLogicCode(poker.code)
            if(tmpMap[code]){
                pokerList.push(poker)
                pokers.splice(index, 1)
                index--
                continue
            }            
        }
        let animList = []
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let tmpFun = function(cb){
                self.playFadeAnim(poker.node, 255, 0, 0.2, 0, ()=>{
                    poker.node.opacity = 255
                    poker.hide()
                    poker.node.stopAllActions()
                    self.pushToUnUseedList(self.m_unUseedHandPokers, poker)
                    cb()
                })
                let targetPos = cc.v2(poker.node.position.x, 60)
                self.playNodeAnim(poker.node, targetPos, null, 0.2)
            }
            animList.push(tmpFun)
        }
        animList.push(function(cb){self.playAdjust(0.2, cb, null, true)})
        self.isPlayingMoveAnim = true
        PromiseUtility.all(animList).then(function(){
            self.isPlayingMoveAnim = false
            onFinish && onFinish()
        })
    }

    playCardInAnim(codeList: number[], onFinish?: Function){
        this.m_isDraging = false
        this.mFirstHoverPoker = null
        this.mLastHoverPoker = null
        let pokerList = this.genPokerList(codeList, true, true, true)
        let len = this.pokers.length        
        let tmpPosData = this.calcPosAndAngle(len - 1, len)
        tmpPosData.localPos.x += this.comingCardPosOffsetX
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            poker.node.position = tmpPosData.localPos
            this.playFadeAnim(poker.node, 0, 255, 0.15)
        }
        this.isPlayingMoveAnim = true
        this.playAdjust(0.2, ()=>{
            this.isPlayingMoveAnim = false
            onFinish && onFinish()
        }, null, true)
    }

    playFaPaiAnim(codeList: number[], onFinish?: Function, onSingleStart?: Function){
        let self = this
        let pokerList = this.genPokerList(codeList, false, false, true)

        let list = []
        let duration = 0.3
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let targetPosData = self.calcPosAndAngle(index, pokerList.length)
            poker.original_pos = targetPosData.localPos
            poker.node.zIndex = targetPosData.zIndex
            let delay = index * 0.1     
            poker.node.position = cc.v2(targetPosData.localPos.x, this.fapaiOffsetY)       
            let tmpFun = function(cb){
                poker.node.scaleX = 0
                self.playNodeAnim(poker.node, targetPosData.localPos, cc.Vec2.ONE, duration, delay, cc.easeBackOut(), cb, onSingleStart)
                self.playFadeAnim(poker.node, 100, 255, duration * 0.8, delay)
            }
            list.push(tmpFun)
        }

        PromiseUtility.all(list).then(function(){
            onFinish && onFinish()
        })
    }

    resetPokers(withAnim?: boolean, onFinish?: Function, params?: any){
        this.m_isDraging = false
        this.mFirstHoverPoker = null
        this.mLastHoverPoker = null
        super.resetPokers(withAnim, onFinish, params)
    }

    protected on_touch_move(poker: PokerTablePokerBase, event: cc.Event.EventTouch){    
        if(this.isPlayingSelectPokerAnim){
            return
        }
        this.on_drag(poker, event)
    }

    protected on_drag(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        this.mLastHoverPoker = poker
        if(!this.mFirstHoverPoker){
            return
        }
        this.on_draging_pokers(2, event)
    }

    protected on_press(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        this.m_isDraging = false
        this.mFirstHoverPoker = poker
        this.mLastHoverPoker = poker        
        this.on_draging_pokers(1, event)
    }

    protected on_press_up(poker: PokerTablePokerBase, event?: cc.Event.EventTouch){
        if(poker != null){
            if(this.mFirstHoverPoker == null){
                this.mFirstHoverPoker = poker
            }
            if(this.mLastHoverPoker == null){
                this.mLastHoverPoker = poker
            }
        }else{
            
        }
        if(this.mLastHoverPoker != null){
            this.on_draging_pokers(3, event)
            this.on_finish_drag_pokers()
        }
        this.m_isDraging = false        
    }


    protected on_draging_pokers(state?: number, event?: cc.Event.EventTouch){
        let poker = this.mFirstHoverPoker
        if(poker){
            let localTouchPos = poker.node.parent.convertToNodeSpaceAR(event.touch.getLocation())
            if(state == 1){                
                this.m_touch_start_offset = poker.node.position.add(localTouchPos.mul(-1))
                this.m_touch_start_pos = localTouchPos
            }else if(state == 2){ 
                if(!this.m_isDraging){
                    let dis = this.m_touch_start_pos.add(localTouchPos.mul(-1)).mag() 
                    if(dis < this.activeDragDistance){
                        return
                    }
                }                      
                if(this.m_touch_start_offset){
                    this.m_isDraging = true
                    let posX = this.m_touch_start_offset.add(localTouchPos).x
                    poker.node.position = cc.v2(posX, poker.node.position.y)
                    poker.node.zIndex = cc.macro.MAX_ZINDEX

                    let needAdjust = false
                    let pokerList = this.pokers
                    for (let i = 0; i < pokerList.length; i++) {
                        let data = this.getPosData(i, pokerList.length)     
                        if(data.localPos.x > posX){                            
                            let index = pokerList.indexOf(poker)
                            needAdjust = true
                            pokerList.splice(index, 1)
                            pokerList.splice(i, 0, poker)
                            break
                        }                        
                    }
                    needAdjust && this.playAdjust(null, null, [poker.node], false, true)
                }                
            }else{
                this.m_touch_start_offset = null
            }       
        }
    }


    protected on_finish_drag_pokers(){
        let self = this
        if(this.m_isDraging){
            if(this.mFirstHoverPoker){
                this.playAdjust(null, null, null, null, true)
            }
            this.mLastHoverPoker = null
            this.mFirstHoverPoker = null
            this.m_dragPokerCallback && this.m_dragPokerCallback(this.pokers.concat())
        }else{
            self.check_drag_mark()
            this.mFirstHoverPoker = null
            this.mLastHoverPoker = null
            let opt = this.check_poker_selected_state()
            this.markAllPokers(false)
            this.refreshPokersMarkState()
            if(this.custom_on_finish_drag_pokers_fun != null){
                return this.custom_on_finish_drag_pokers_fun()
            }
            if(opt.markedList.length > 1 && opt.selectedList.length > 1 && this.on_finish_drag_pokers_reselect_fun){
                this.on_finish_drag_pokers_reselect_fun()
            }else{
                this.isPlayingSelectPokerAnim = true
                this.refreshPokerSelectState(true, function(){
                    self.isPlayingSelectPokerAnim = false
                })
            }
        }
    }

    sortPokers(type: number, withAnim?: boolean){
        let self = this
        let pokers = self.pokers
        let doSort = function(){
            if(type == 1){
                pokers.sort(self.sortPokerListByColorFirst)
            }else{
                pokers.sort(self.sortPokerListByIndexFirst)
            }
            if(withAnim){
                self.playAdjust(0.2, null, null, null, true)
            }else{
                self.formatPokersLayout(pokers)
            }
            
            self.m_dragPokerCallback && self.m_dragPokerCallback(self.pokers.concat())
        }
        if(withAnim){
            // self.playAdjust(0.4, function(){
            //     doSort()
            // }, null, null, true, function(index, total){
            //     let data: any = {}
            //     data.localPos = cc.Vec2.ZERO
            //     data.worldPos = self.nodePokersParent.convertToWorldSpaceAR(data.localPos)
            //     data.zIndex = index
            //     return data
            // })
            doSort()
        }else{
            doSort()
        }
        
    }

    protected refreshPokersMarkState(){
        
    }


    protected sortPokerListByColorFirst(poker1: PokerTablePokerBase, poker2: PokerTablePokerBase){        
        let card1 = Card.makeCardByCode(poker1.code)
        let card2 = Card.makeCardByCode(poker2.code)
        if(card1.color == card2.color){
            return card1.logicIndex - card2.logicIndex
        }
        return card1.color - card2.color
    }

    protected sortPokerListByIndexFirst(poker1: PokerTablePokerBase, poker2: PokerTablePokerBase){        
        let card1 = Card.makeCardByCode(poker1.code)
        let card2 = Card.makeCardByCode(poker2.code)
        if(card1.index == card2.index){
            return card1.color - card2.color
        }
        return card1.logicIndex - card2.logicIndex
    }
}
